import { motion, useInView } from "framer-motion";
import { useRef } from "react";

const MAPS_LINK = "https://www.google.com/maps/place//data=!4m2!3m1!1s0x132f783c46eacbd3:0xf754ca92e2a42d9d?sa=X&ved=1t:8290&ictx=111";

const MapSection = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-50px" });

  return (
    <section ref={ref} className="section-light py-16 px-6 md:px-12">
      <div className="max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8 }}
          className="overflow-hidden rounded-sm"
        >
          <iframe
            title="Danielealoisi sede su Google Maps"
            src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d2971.5!2d12.7!3d42.0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x132f783c46eacbd3%3A0xf754ca92e2a42d9d!2s!5e0!3m2!1sit!2sit!4v1700000000000"
            width="100%"
            height="400"
            style={{ border: 0 }}
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            className="w-full"
          />
        </motion.div>
        <motion.div
          initial={{ opacity: 0 }}
          animate={isInView ? { opacity: 1 } : {}}
          transition={{ duration: 0.6, delay: 0.3 }}
          className="mt-6 text-center"
        >
          <a
            href={MAPS_LINK}
            target="_blank"
            rel="noopener noreferrer"
            className="cta-button-light hover:-translate-y-0.5 active:scale-[0.98] transition-all duration-300"
          >
            Apri su Google Maps
          </a>
        </motion.div>
      </div>
    </section>
  );
};

export default MapSection;